import { render, staticRenderFns } from "./PlTermsOfUse.vue?vue&type=template&id=c869bfa4&scoped=true"
import script from "./PlTermsOfUse.vue?vue&type=script&lang=js"
export * from "./PlTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c869bfa4",
  null
  ,true
)

export default component.exports